<template>
  <router-view></router-view>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {}
</script>
